import { render, staticRenderFns } from "./ProductCyclopediaPropertiesEditor.vue?vue&type=template&id=62e9a79f&scoped=true&"
import script from "./ProductCyclopediaPropertiesEditor.vue?vue&type=script&lang=js&"
export * from "./ProductCyclopediaPropertiesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e9a79f",
  null
  
)

export default component.exports